import { render } from "./Agreements.vue?vue&type=template&id=6d1a73c8"
import script from "./Agreements.vue?vue&type=script&lang=js"
export * from "./Agreements.vue?vue&type=script&lang=js"

import "./Agreements.vue?vue&type=style&index=0&id=6d1a73c8&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__